// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__38Q2v","label":"styles_label__2mX7r"};